import React, { useEffect, useState } from 'react';
import { Button, Drawer, Form, Spin, Steps } from 'antd';
import { observer } from 'mobx-react';
import FormComponent from './FormComponent.js';
import useStore from '../../../../store';
import {
	displayFormats,
	Notification,
	templeSteps,
} from '../../../../config/Global';
import Message from '../../../../config/Message';
import dayjs from 'dayjs';
import TempleImageUpload from './ImageUpload.js';
import RoutineForm from './RoutineFormComponent.js';

const EditComponent = observer((props) => {
	const { visible, onClose, viewMode } = props;
	const [form] = Form.useForm();
	const { TEMPLE, ROOT, AUTH } = useStore();
	const { templeBasicDetail, templeTimingDetail, templeImageDetails } =
		TEMPLE;
	const [current, setCurrent] = useState(0);
	const [formID, setFormID] = useState('EditForm');
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);
	const [isLiveDarshan, setIsLiveDarshan] = useState(false);
	const [cameraAllowed, setCameraAllowed] = useState(false);
	const [fileLists, setFileLists] = useState({});
	const [tempState, setTempState] = useState(true);
	const [templeStep, setTempleStep] = useState(templeSteps);
	const {
		AUTH: { stateList, cityList },
	} = useStore();
	const [tempNamee, setTempName] = useState();
	const [stateName, setStateName] = useState();
	const [cityName, setCityName] = useState();
	// const [isChecked, setIsChecked] = useState(false);
	const [getDarshanTimeData, setGetDarshanTimeData] = useState(null);
	const [propertyOverView, setPropertyOverView] = useState({})
	const [propertyOptions, setPropertyOptions] = useState({})

	// const testBlurEv = () => {
	// 	const {
	// 		templeName,
	// 		eCityId,
	// 		eStateId,
	// 		metaTitle,
	// 		metaDescription,
	// 		metaKeywords,
	// 	} = form.getFieldsValue();
	// 	let getStateName = stateList.find(
	// 		(_X) => _X.eRegionId === eStateId
	// 	)?.regionName;
	// 	let getCityName = cityList.find(
	// 		(_X) => _X.eRegionId === eCityId
	// 	)?.regionName;
	// 	let metaKeywordsdd = metaKeywords;
	// 	metaKeywordsdd = metaKeywordsdd.replace(
	// 		stateName ? stateName : 'stateName',
	// 		getStateName || 'stateName'
	// 	);
	// 	metaKeywordsdd = metaKeywordsdd.replace(
	// 		cityName ? cityName : 'cityName',
	// 		getCityName || 'cityName'
	// 	);
	// 	form.setFieldsValue({
	// 		metaTitle: metaTitle.replace(
	// 			new RegExp(tempNamee ? tempNamee : 'templeName', 'g'),
	// 			templeName || 'templeName'
	// 		),
	// 		metaDescription: metaDescription.replace(
	// 			new RegExp(tempNamee ? tempNamee : 'templeName', 'g'),
	// 			templeName || 'templeName'
	// 		),
	// 		metaKeywords: metaKeywordsdd,
	// 	});
	// 	setTempName(templeName);
	// 	setStateName(getStateName);
	// 	setCityName(getCityName);
	// };

	const handleBasicDetailsSubmit = async (data) => {
		setSaving(true);
		const payloadModal = {
			...data,
			id: templeBasicDetail.id,
			isLiveDarshan: isLiveDarshan,
			isActive: templeBasicDetail.isActive,
			cameraAllowed: cameraAllowed,
			versionNo: templeBasicDetail.versionNo,
			// metaTitle: isChecked ? data.metaTitle : null,
			// metaKeywords: isChecked ? data.metaKeywords : null,
			// metaDescription: isChecked ? data.metaDescription : null,
			seoTitle: data.seoTitle || null,
			faQs: data.faqs.length ? JSON.stringify(data.faqs) : null,
			faQsSchema: data.faQsSchema ? data.faQsSchema.replace(/(\r\n|\n|\r)/g, '') || '' : '',
			propertyOverview: JSON.stringify(propertyOverView),
			nearByProperty: JSON.stringify(propertyOptions)
		};
		delete payloadModal.faqs
		await TEMPLE.editTemple(payloadModal)
			.then((data) => {
				if (
					data.message === 'Errors occured. Please try again later.'
				) {
					Notification.error({
						message: data.message,
					});
				} else {
					Notification.success({
						message: Message().CRUD.UPDATE('Temple'),
					});
					setPropertyOverView({})
					setPropertyOptions({})
					form.resetFields();
					AUTH.getAllByLookupKeyList(
						`lookupKey=TEMPLETIMINGTYPE&isAdmin=false`
					);
					handleTempleRoutin();
				}
			})
			.catch((e) => {
				const errorData = ROOT.assignErrorToInput(e);
				form.setFieldsValue({ error: errorData });
			})
			.finally(() => setSaving(false));
	};

	const handleChange = () => {
		setTempState(!tempState);
		if (formID === 'EditTempleImageUploadForm') {
			setTimeout(() => {
				form.validateFields({ validateOnly: true })
					.then(() => {
						if (form.getFieldsValue().templeImageList.length) {
							if (
								form.getFieldsValue().templeImageList.length ===
								Object.keys(fileLists).length
							) {
								setDisabled(false);
							} else {
								setDisabled(true);
							}
						} else {
							setDisabled(true);
						}
					})
					.catch(() => {
						// setDisabled(true);
					});
			});
		} else if (formID === 'EditRoutineForm') {
			setTimeout(() => {
				form.validateFields({ validateOnly: true })
					.then(() => {
						if (
							form.getFieldsValue().templeTimingAddModelList
								.length
						) {
							setDisabled(false);
						} else {
							setDisabled(true);
						}
					})
					.catch(() => {
						// setDisabled(true);
					});
			}, 0);
		} else {
			setTimeout(() => {
				form.validateFields({ validateOnly: true })
					.then(() => {
						setDisabled(false);
					})
					.catch((err) => {
						if (err.errorFields.length) {
							setDisabled(true);
						}
					});
			}, 0);
		}
	};

	const handleTempleRoutin = async () => {
		setDisabled(true);
		setFormID('EditRoutineForm');
		setCurrent(1);
		const templeTimingData = await TEMPLE.ReadTempleTimingdetail(
			templeBasicDetail.id
		);
		templeTimingData &&
			templeTimingData.length &&
			templeTimingData.forEach((timingData) => {
				timingData['key'] = timingData.id;
				timingData['time'] = [
					dayjs(timingData.fromTime, displayFormats.TIME_FORMAT),
					dayjs(timingData.toTime, displayFormats.TIME_FORMAT),
				];
			});
		setGetDarshanTimeData(templeTimingData);
		form.setFieldsValue({ templeTimingAddModelList: templeTimingData });
	};

	const handleImageUploadScreen = async () => {
		setDisabled(true);
		let reqPayload = {
			tableName: 'temple',
			templeID: templeBasicDetail.id,
		};
		const templeImageData = await TEMPLE.ReadTempleImagedetail(reqPayload);
		const newFileLists = {};
		await templeImageData.forEach((item, index) => {
			newFileLists[index] = [
				{
					uid: item.id,
					name: item.filename,
					url: item.bunnyLink || URL.createObjectURL(item.bunnyLink),
					status: 'done', // e.g., done, uploading, error
				},
			];
		});
		setFileLists(newFileLists);
		const tempArray = [];
		await templeImageData.forEach((_x, index) => {
			const tempObj = {};
			tempObj['Description'] = _x.description;
			tempObj['ImageType'] = _x.imageType;
			tempObj['fileList'] = [newFileLists[index]];
			tempArray.push(tempObj);
		});
		form.setFieldsValue({ templeImageList: tempArray });
		setFormID('EditTempleImageUploadForm');
		setCurrent(2);
	};

	const handleRoutineSubmit = async (data) => {
		setSaving(true);
		let array2Ids = new Set(
			data.templeTimingAddModelList.map((obj) => obj.id)
		);
		await templeTimingDetail.forEach((_x) => {
			if (!array2Ids.has(_x.id)) {
				data.templeTimingAddModelList.push({ ..._x, isActive: false });
			}
		});
		if (
			data.templeTimingAddModelList &&
			data.templeTimingAddModelList.length
		) {
			data.templeTimingAddModelList.forEach((_X, index) => {
				data.templeTimingAddModelList[index]['eTempleId'] =
					templeBasicDetail.id;
				data.templeTimingAddModelList[index]['fromTime'] =
					dayjs(
						data.templeTimingAddModelList[index]?.['time']?.[0]
					).format(displayFormats.TIME_FORMAT) ||
					data.templeTimingAddModelList[index]['fromTime'];
				data.templeTimingAddModelList[index]['toTime'] =
					dayjs(
						data.templeTimingAddModelList[index]?.['time']?.[1]
					).format(displayFormats.TIME_FORMAT) ||
					data.templeTimingAddModelList[index]['toTime'];
				delete data.templeTimingAddModelList?.[index]?.['time'];
			});
		}
		TEMPLE.updateRoutine(data?.templeTimingAddModelList)
			.then((data) => {
				if (data.httpStatusCode === 200) {
					Notification.success({
						message: Message().CRUD.ADD("Temple's Routine"),
					});
					form.resetFields();
					AUTH.getAllByLookupKeyList(
						`lookupKey=IMAGETYPE&isAdmin=false`
					);
					setTempleStep((prev) => {
						const updatedArray = [...prev];
						updatedArray[1] = {
							...updatedArray[1],
							status: 'finish',
						};
						TEMPLE.templeTimingDetail = null;
						return updatedArray;
					});
					handleImageUploadScreen();
				} else {
					Notification.error({
						message: data,
					});
				}
			})
			.catch((e) => { })
			.finally(() => {
				setSaving(false);
				setDisabled(true);
			});
	};

	const TempleImageUploadSubmit = async (data) => {
		setSaving(true);
		await data.templeImageList.forEach(async (item) => {
			if (
				Object.keys(item).includes('fileList') &&
				Object.keys(item.fileList).length === 2
			) {
				const formData = new FormData();
				formData.append('RefTablename', 'temple');
				formData.append('ERefRecordid', templeBasicDetail.id);
				Object.keys(item).forEach((keyName) => {
					if (['Description', 'ImageType'].includes(keyName)) {
						formData.append(keyName, item[keyName]);
					} else {
						formData.append(
							'Imagefile',
							item.fileList.fileList[0].originFileObj
						);
					}
				});
				await AUTH.ImageUpload(formData)
					.then((data) => {
						if (typeof data !== 'string') {
							setCurrent(0);
						} else {
							Notification.error({
								message: data,
							});
						}
					})
					.catch((e) => { })
					.finally(() => setSaving(false));
			}
		});
		Notification.info({ message: 'Image uploading start in background.' });
		setTempleStep(templeSteps);
		setFormID('EditForm');
		closeModal();
		setSaving(false);
	};

	const closeModal = () => {
		form.resetFields();
		setCurrent(0);
		setFormID('EditForm');
		// setTempState(!tempState);
		if (!viewMode) {
			TEMPLE.agGrid.api.resetColumnState();
			TEMPLE.setupGrid(TEMPLE.agGrid);
		}
		setDisabled(true);
		AUTH.lookupKeyList = [];
		AUTH.stateList = [];
		AUTH.cityList = [];
		setFileLists({});
		TEMPLE.templeBasicDetail = null;
		TEMPLE.templeTimingDetail = null;
		TEMPLE.templeImageDetails = null;
		// setIsChecked(false)
		onClose();
	};

	const onTabChange = async (e) => {
		setCurrent(e);
		AUTH.lookupKeyList = [];
		if (e === 1) {
			setFormID('EditRoutineForm');
			TEMPLE.ReadTempleTimingdetail(templeBasicDetail.id);
			AUTH.getAllByLookupKeyList(
				`lookupKey=TEMPLETIMINGTYPE&isAdmin=false`
			);
			if (!templeTimingDetail) {
				await handleTempleRoutin();
			}
		} else if (e === 2) {
			TEMPLE.templeTimingDetail = null;
			// AUTH.getAllByLookupKeyList(`lookupKey=IMAGETYPE&isAdmin=false`);
			if (!templeImageDetails) {
				await handleImageUploadScreen();
			}
			setFormID('EditTempleImageUploadForm');
		} else if (e === 0 && templeBasicDetail) {
			TEMPLE.templeTimingDetail = null;
			TEMPLE.ReadTempleBasicList(templeBasicDetail.id);
			AUTH.getAllByLookupKeyList(`lookupKey=popularity&isAdmin=false`);
			setFormID('EditForm');
			form.setFieldsValue(templeBasicDetail);
		}
	};

	useEffect(() => {
		if (visible && templeBasicDetail) {
			// if (templeBasicDetail.metaTitle || templeBasicDetail.metaDescription || templeBasicDetail.metaKeywords) {
			// 	setIsChecked(true)
			// }
			form.setFieldsValue({ ...templeBasicDetail, faqs: (templeBasicDetail.faQs && JSON.parse(templeBasicDetail.faQs)) ? JSON.parse(templeBasicDetail.faQs) : [{}] });
			form.setFieldsValue()
			setPropertyOverView(templeBasicDetail.propertyOverview && JSON.parse(templeBasicDetail.propertyOverview) !== null ? JSON.parse(templeBasicDetail.propertyOverview) : {})
			setPropertyOptions(templeBasicDetail.nearByProperty && JSON.parse(templeBasicDetail.nearByProperty) !== null ? JSON.parse(templeBasicDetail.nearByProperty) : {})
			setTempName(templeBasicDetail.templeName);
			setStateName(templeBasicDetail.stateName);
			setCityName(templeBasicDetail.cityName);
			if (templeBasicDetail.isLiveDarshan) {
				setIsLiveDarshan(true);
			}
			if (templeBasicDetail.cameraAllowed) {
				setCameraAllowed(true);
			}
		}
	}, [visible, form, templeBasicDetail]);

	return (
		<Drawer
			title={viewMode ? 'View Temple' : 'Edit Temple'}
			onClose={closeModal}
			open={visible}
			destroyOnClose
			width={'80%'}
			footer={
				<div style={{ textAlign: 'right' }}>
					{/* <Button type="primary" key={1} disabled={current}>
						Prev
					</Button> */}
					{!viewMode && (
						<Button
							type="primary"
							key={2}
							disabled={disabled}
							htmlType="submit"
							loading={saving}
							style={{ marginLeft: '20px' }}
							form={formID}
						>
							{templeStep.length - 1 === current
								? 'Upload & Submit'
								: 'Save & Next'}
						</Button>
					)}
					<Button
						key={3}
						onClick={closeModal}
						style={{ marginLeft: '20px' }}
					>
						Cancel
					</Button>
				</div>
			}
		>
			<Spin spinning={!TEMPLE.templeBasicDetail}>
				<Steps
					items={templeStep}
					current={current}
					onChange={(e) => onTabChange(e)}
					style={{
						marginBottom: 24,
					}}
				/>
				{current === 0 ? (
					<Spin spinning={!TEMPLE.templeBasicDetail}>
						<FormComponent
							id="EditForm"
							form={form}
							onFinish={handleBasicDetailsSubmit}
							handleChange={handleChange}
							isLiveDarshan={isLiveDarshan}
							setIsLiveDarshan={setIsLiveDarshan}
							cameraAllowed={cameraAllowed}
							setCameraAllowed={setCameraAllowed}
							viewMode={viewMode}
							propertyOverView={propertyOverView}
							setPropertyOverView={setPropertyOverView}
							propertyOptions={propertyOptions}
							setPropertyOptions={setPropertyOptions}
						// testBlurEv={testBlurEv}
						// isChecked={isChecked}
						// setIsChecked={setIsChecked}
						/>
					</Spin>
				) : current === 1 ? (
					<RoutineForm
						id="EditRoutineForm"
						form={form}
						onFinish={handleRoutineSubmit}
						handleChange={handleChange}
						viewMode={viewMode}
						getDarshanTimeData={getDarshanTimeData}
						loading={saving}
					/>
				) : current === 2 ? (
					<TempleImageUpload
						id="EditTempleImageUploadForm"
						form={form}
						onFinish={TempleImageUploadSubmit}
						handleChange={handleChange}
						fileLists={fileLists}
						setFileLists={setFileLists}
						viewMode={viewMode}
					/>
				) : null}
			</Spin>
		</Drawer>
	);
});

export default EditComponent;
